/* tq-header · putters panel, mobile drawer, solid-on-scroll. No dependencies. */
(() => {
  const header = document.querySelector('[data-tq-header]');
  if (!header) return;
  const scrim = document.querySelector('[data-tq-scrim]');

  /* Solid background once the page moves (homepage overlay mode only) */
  const overlay = header.classList.contains('tq-header--overlay');
  let panelOpen = false;
  const setSolid = () => header.classList.toggle('is-solid', panelOpen || window.scrollY > 8);
  if (overlay) setSolid();

  /* Hide while reading down the page, return on any scroll up */
  let lastY = window.scrollY;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (overlay) setSolid();
    if (!panelOpen) header.classList.toggle('is-hidden', y > lastY && y > 160);
    lastY = y;
  }, { passive: true });

  /* Putters panel: opens on click, or hover with a short intent delay */
  const trigger = header.querySelector('[data-tq-mega]');
  const panel = header.querySelector('[data-tq-mega-panel]');
  let hoverTimer;
  const openPanel = (open) => {
    if (!trigger || !panel) return;
    panelOpen = open;
    trigger.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
    scrim.hidden = !open;
    if (overlay) setSolid();
  };
  if (trigger && panel) {
    trigger.addEventListener('click', () => openPanel(!panelOpen));
    const hoverIn = () => { clearTimeout(hoverTimer); hoverTimer = setTimeout(() => openPanel(true), 120); };
    const hoverOut = () => { clearTimeout(hoverTimer); hoverTimer = setTimeout(() => openPanel(false), 220); };
    if (window.matchMedia('(hover: hover)').matches) {
      [trigger, panel].forEach((el) => { el.addEventListener('mouseenter', hoverIn); el.addEventListener('mouseleave', hoverOut); });
    }
    scrim.addEventListener('click', () => openPanel(false));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panelOpen) { openPanel(false); trigger.focus(); }
    });
    panel.addEventListener('focusout', (e) => {
      if (!panel.contains(e.relatedTarget) && e.relatedTarget !== trigger) openPanel(false);
    });
  }

  /* Mobile drawer */
  const drawer = document.querySelector('[data-tq-drawer]');
  const openBtn = header.querySelector('[data-tq-drawer-open]');
  const closeBtn = document.querySelector('[data-tq-drawer-close]');
  const setDrawer = (open) => {
    drawer.hidden = !open;
    openBtn.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('tq-locked', open);
    (open ? closeBtn : openBtn).focus();
  };
  if (drawer && openBtn && closeBtn) {
    openBtn.addEventListener('click', () => setDrawer(true));
    closeBtn.addEventListener('click', () => setDrawer(false));
    drawer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') setDrawer(false);
      if (e.key !== 'Tab') return;
      const f = drawer.querySelectorAll('a[href], button, summary');
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    window.matchMedia('(min-width: 1024px)').addEventListener('change', (m) => { if (m.matches && !drawer.hidden) setDrawer(false); });
  }
})();
